/**
 * Should a failed request be retried?
 *
 * Only transient failures are worth a second attempt. Everything listed here
 * is terminal against this backend:
 * - `401`/`406` — the session is gone; the API client already tried a token
 *   renewal, so React Query retrying would just replay the failure.
 * - `403`, `422` — the answer will not change.
 * - `400` — overloaded: unknown route *and* "role denied". Neither is transient.
 * - `404` — "no such record" and, in production, every unhandled exception.
 * - `0` — a client-synthesized failure (network error or a malformed body).
 *   This one matters: the previous version defaulted an unrecognised error to
 *   `0` and returned `true`, so *every* failure was retried three times.
 *
 * @param status the HTTP status, or 0 when the request never completed
 */
export const isRetryOnStatus = (status: number): boolean => {
  const terminalStatuses: number[] = [0, 400, 401, 403, 404, 406, 422, 500];
  return !terminalStatuses.includes(status);
};
